<template>
  <div class="container">

    <div class="neir">
      <div class="l">
        <img class="topimg" src="@/assets/image/697.png" alt="">
      </div>
      <div class="r">
        <div class="t">
          <div class="lT">
            <ul class="list">
              <li class="active">好文推荐 <p></p></li>
            </ul>
          </div>
          <ul class="lB">
            <li v-for="item in pagelist2" :key="item.id" @click="goinfo(item.id)">
              <img :src="item.picUrl" alt="">
              <div>
                <h3>{{item.name}}</h3>
                <p>好评1720</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="title"><span>首页</span>>  PETCT/MR资讯</div>
    <div class="listbox">
      <ul class="lB">
        <!--@click="goinfo"-->
        <li  v-for="item in pagelist" :key="item.id" @click="goinfo(item.id)">
          <div>
            <h3>{{item.name}}</h3>
            <p class="js">
              {{item.introduction}}
            </p>
            <p>
              <i class="el-icon-view"></i> {{item.viewNum}}次观看数<span class="time">{{item.createTime}}</span>
            </p>
          </div>
        </li>
      </ul>
      <div class="page">
        <el-pagination
          background
          layout="pager"
          :total="total">
        </el-pagination>
      </div>
    </div>

  </div>
</template>

<script>
  // import commonTable from '@/components/commonTable.vue'
  import server from '@/service/server.js'
export default {
    name: 'index',
  components: {
    // commonTable
  },
    data () {
        return {
          showHeader: false,
          pagelist: [],
          pagelist2: [],
          current: 1,
          total: 0
        }
    },
    methods: {
      goinfo(id) {
        this.$router.push({
          path: `/yyznxq?id=${id}&type=zx`
        })
      },
      chanePage(e) {
        this.current = e
        this.list()
      },
      list() {
        server.information({
          current: this.current,
          size: 10
        }).then((res) => {
          this.pagelist = res.data.records
          this.total = res.data.total
        })
      },
    },

    mounted(){
      this.list()
      server.informationTj(1).then((res) => {
        this.pagelist2 = res.data
      })
    }

}
</script>
<style lang="scss" scoped>
  .container {
    width: 1370px;
    margin: 0 auto;
    .title {
      padding: 10px 20px;
      background-color: #FFFFFF;
      margin: 20px 0;
      font-size: 16px;
      span {
        color: #5288F0;
      }
    }
    .neir{
      display: flex;
      margin-top: 10px;
      .topimg {
        display: block;
        width: 100%;
        height: 100%;

      }
      .l{
        width: 1010px;
      }
      .r{
       margin-left: auto;
        .t{
          width: 344px;
          /*height: 587px;*/
          background: #FFFFFF;
          border: 2px solid #EAEBEB;
          border-radius: 5px;
          .lT{
            width: 100%;
            .list{
              margin-bottom: 10px;
              li{
                text-align: center;
                cursor: pointer;
                font-size: 19px;
                /*font-family: Adobe Heiti Std;*/;
                font-weight: normal;
                color: #000000;
                line-height: 33px;
                padding-top: 10px;
                border-bottom: 2px solid #EAEBEB;;
                p{
                  width: 97px;
                  height: 4px;
                  background: rgba(0, 180, 247, 0);
                  margin: 10px auto 0;
                }
              }
              li.active{
                p{
                  background: rgba(0, 180, 247, 1);
                }
              }
            }
          }
          .lB{
            width: 100%;
            padding: 0 20px;
            li{
              display: flex;
              margin-bottom: 20px;
              img{
                width: 103px;
                height: 72px;
              }
              div{
                padding: 4px 0;
                margin-left: 10px;
                width: calc(100% - 140px);
                h3{
                  font-size: 15px;
                  /*font-family: Adobe Heiti Std;*/;
                  font-weight: normal;
                  color: #040000;
                  width: 100%;
                  overflow:hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                }
                p{
                  font-size: 14px;
                  /*font-family: Adobe Heiti Std;*/;
                  font-weight: normal;
                  color: #E1E4EA;
                  margin-top: 15px;
                }
              }
            }
          }
        }
        .b{
          margin-left: 16px;
          margin-top: 36px;
          width: 323px;
          height: 581px;
          border: 1px solid #E1E3EA;
          box-shadow: 0px 3px 7px 0px rgba(35,24,21,0.35);
          border-radius: 15px;
          padding: 10px;
          p{
            font-size: 21px;
            /*font-family: Adobe Heiti Std;*/;
            font-weight: normal;
            color: #000000;
            border-bottom: 1px solid rgba(210, 214, 214, 1);
            line-height: 32px;
            padding: 5px 0;
          }
          ul{
            li{
              i{
                width: 6px;
                height: 6px;
                background: #000;
                border-radius: 50%;
                display: inline-block;
                vertical-align: middle;
                margin-right: 10px;
              }
              font-size: 17px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #000000;
              width: calc(100% - 20px);
              overflow:hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              margin-top: 10px;
            }
          }
        }
      }
    }
    .listbox {
      background: #fff;
      margin-top: 15px;
      margin-bottom: 15px;
      .lB{
        width: 100%;
        padding: 0 20px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        li{
          width: 46%;
          border-bottom: 1px solid rgba(209, 213, 213, 1);
          display: flex;
          margin-top: 10px;
          padding-bottom: 10px;
          cursor: pointer;
          &:hover {
            h3 {
              color: #CB0E07;
            }
            p{
              color: #d64944;
            }
          }
          div{
            padding: 10px 0;
            /*margin-left: 40px;*/
            /*width: calc(100% - 280px);*/
            h3{
              font-size: 20px;
              /*font-family: Adobe Heiti Std;*/;
              font-weight: bold;
              color: #040000;
              transition: all 0.5s;
            }
            p:nth-child(2){
              margin: 10px 0;
            }
            p{
              font-size: 16px;
              font-weight: 400;
              color: #B3B6BA;
              transition: all 0.5s;
            }
            p:nth-child(3){
              /*display: flex;*/
              i {
                vertical-align: middle;
              }
              span:nth-child(2){
                font-size: 16px;
                font-weight: 400;
                margin-left: 10px;
              }
            }
          }
        }
      }
      .page {
        padding: 30px;
        text-align: center;
      }
    }

  }
  @media (max-width: 750px) {
    .container {
      width: 100%;
      margin-top: 60px;
      .neir {
        .r {
          display: none;
        }
      }
      .listbox {
        .lB {
          display: block;
          li {
            width: 100%;
            div {
              h3 {
                font-size: 16px;
              }
              .js {
                text-overflow: ellipsis;
                display: -webkit-box;
                word-break: break-all;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                height: 56px;
                line-height: 28px;
                overflow: hidden;
              }
            }
          }
        }
      }
    }
  }
</style>
